class DefaultErrorReporter {
    shouldReportErrors = false;
    setUpErrorReporting() {
        // No-op: Default implementation does not set up external error reporting
    }
    reportError(error, data) {
        console.error('[ErrorReporter]', error.message, data || '');
    }
    reportMessage(message, data) {
        console.warn('[ErrorReporter]', message, data || '');
    }
    async getErrorData() {
        return {
            tenant: 'none',
            user: 'none',
            terminal: 'none',
            appName: 'app-core',
            electronAppRelease: null
        };
    }
}
export const defaultErrorReporter = new DefaultErrorReporter();
//# sourceMappingURL=DefaultErrorReporter.js.map